<template>
<div >
    <pt-sub-title title="商品信息"></pt-sub-title>
    <table :class="$style['message-table']">
        <pt-form-list-item label="选择优惠券：" required  @widthItem="widthItem" :widthMax="widthMax" v-if="isShowSelectCoupon">
          <wt-input :class="$style['goods-name']" v-model="coupon_length" style="display:none" data-vv-as="请至少选择一个优惠券" name="name"  v-validate="'required|selectArr'" ></wt-input>
            <el-button  type="primary" plain @click="selectCoupon" :class="$style['table-of-button']">选择优惠券</el-button>
           <div class="page-background" v-if="showSelectCouponTable">
              <table :class="$style['goods-table']">
                  <tr>
                    <td>优惠劵</td>
                    <td>使用形式</td>
                    <td>优惠形式</td>
                    <td>内容</td>
                    <!-- <td>已领取/剩余</td> -->
                    <td>有效期</td>
                    <!-- <td>发布方式</td> -->
                    <td>状态</td>
                    <td><span style="color:red">*</span>兑换数量</td>
                    <td></td>
                  </tr>
                  <tr v-for="(item,index) in coupon_list" :key="index">
                    <td>{{item.couponData&&item.couponData.name}}</td>
                    <td>
                      {{item.used_type}}
                      <!-- <div>{{coupon_list.discount}}</div>
                      <div>满{{coupon_list.thresholdOfAmount}}元可使用</div> -->
                    </td>
                    <!-- <td>
                      {{coupon_list.amount?coupon_list.amount:'不限'}}

                      </td> -->
                      <td>{{item.discountType}}</td>
                      <td><div>{{item.discount}}</div>
                      <div>满{{item.thresholdOfAmount}}元可使用</div></td>
                      <!-- <td>{{coupon_list.usedAmount}}/{{coupon_list.amount?coupon_list.surplusAmount:'不限'}}</td> -->
                      <td>{{item.validity_date}}</td>
                      <!-- <td>{{coupon_list.publishType}}</td> -->
                      <td>{{item.coupon_status}}</td>
                      <td><wt-input v-model="item.couponAmount" @change="changeCouponAmount(item.couponAmount,item.id)" data-vv-as="优惠券兑换数量" type="number" v-validate="'required|gtezero'"></wt-input></td>
                      <td><el-button type="text" @click="getCouponsDetail(item)">详情</el-button></td>
                  </tr>
              </table>
           </div>
        </pt-form-list-item>
        <pt-form-list-item label="选择基因商品：" required  @widthItem="widthItem" :widthMax="widthMax" v-if="isShowSelectGoods">
            <wt-input placeholder="选择基因商品" data-vv-as="选择基因商品" style="display:none" v-model="goodsData.mallGoodsId" name="name"  v-validate="'required'"></wt-input>
            <el-button  type="primary" plain @click="selectGoods" :class="$style['table-of-button']">选择商品</el-button>
            <div class="page-background" v-if="showGoodsTable">
              <table :class="$style['goods-table']">
                  <tr>
                      <td>商品名称</td>
                      <td>价格（元）</td>
                      <td v-if="showStockQuantity">库存（件）</td>
                  </tr>
                  <tr >
                      <td>{{goods_list.goodsDTO&&goods_list.goodsDTO.goodsData&&goods_list.goodsDTO.goodsData.name}}</td>
                      <td>{{goods_list.final_price}}</td>
                      <td v-if="showStockQuantity">{{goods_list.goodsOtherInfoDTO&&goods_list.goodsOtherInfoDTO.stockQuantity}}</td>
                  </tr>
            </table>
            </div>
        </pt-form-list-item>
        <pt-form-list-item label="商品名称：" :required="true" >
            <wt-input placeholder="请输入商品名称" :class="$style['goods-name']" v-model="goodsData.name" data-vv-as="商品名称" name="name"  v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="商品描述：" :required="true">
            <wt-input placeholder="请输入商品描述" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}"
            :class="$style['input-style']"   v-model="goodsData.description" data-vv-as="商品描述" name="name"  v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="商品分组：" :required="true">
            <div>
                <wt-selector :options="goodsGroup" v-model="goodsData.groupId"  :props="{label: 'name',value: 'id'}" data-vv-as="商品分组" name="name"  v-validate="'required'"></wt-selector>
                <el-button style="margin-left:10px" type="text" @click="setGroup">分组设置</el-button>
            </div>
        </pt-form-list-item>
        <pt-form-list-item label="商品主图：" :required="true">
            <template>
                <wt-upload-file class="main-pictrue-upload" :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
                v-model="goodsData.mainPicture" data-vv-as="商品主图" name="name"  v-validate="'required'" :multiple="false">
                    <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
                </wt-upload-file>
                <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694*694像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="商品图：" :required="true" v-if="!goodsData.isExternalUrl">
            <template>
            <wt-upload-file  class="goods-pictrue-upload" :class="$style['goods-pictrue-upload']" :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
            v-model="goodsData.pictures" data-vv-as="商品图" name="name"  v-validate="'required'">
                <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
            </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694*490像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="广告位图片：" :required="true">
            <template>
                <wt-upload-file :action="uploadApi" class="goods-banner-pictrue-upload"  :class="$style['goods-banner-pictrue-upload']" :data="picture_params" :img-url="privateResourcesUrl"
                v-model="goodsData.bannerPicture" :multiple="false" data-vv-as="广告位图片" name="name"  v-validate="'required'">
                    <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
                </wt-upload-file>
                <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694x256像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="商品规格：" required >
          <wt-input placeholder="选择基因商品" data-vv-as="至少选择一个商品规格" style="display:none" v-model="specifications.length" name="name"  v-validate="'required|selectArr'"></wt-input>
            <el-button type="primary" plain v-if="!specifications||specifications.length===0" @click="addSpecifications">点击添加规格</el-button>
            <specification-table v-else v-model="specifications"  :type="goodsData.type" :allowAddSpecifications="allowAddSpecifications"></specification-table>
            <!-- <wt-input v-if="goodsData.justShow" v-model="specifications[0].items[0].name" data-vv-as="商品规格" name="name"  v-validate="'required'" style="display:none"></wt-input> -->
        </pt-form-list-item>
        <pt-form-list-item label="规格明细：" v-if="specifications&&specifications.length">
            <div :class="$style['specification-table-div']" class="page-background">
            <table :class="$style['specification-table']">
                <th>
                    <td>
                        <!-- 报告形式 -->
                        </td>
                    <td><span style="color:red">*</span>所需积分</td>
                    <td v-if="showStockQuantity"><span  style="color:red">*</span>库存</td>
                    <!-- <td>操作</td> -->
                    <!-- <td v-if="isShowPromotionPrice">折后价</td>
                    <td>邀请人奖励</td>
                    <td>业务员奖励</td> -->
                </th>
                <tr v-for="(etem,index) in specifications" :key="index">
                    <td>{{etem.name}}</td>
                    <td><div :class="$style['specifications-tr-input-div']">
                        <wt-input v-model="etem.price" @change="showPriceInput" @focus="showPriceFocus(index)" data-vv-as="规格所需积分" name="name"  :class="$style['specifications-tr-input']" v-validate="'required|decimal:2|min_value:0|is_not:0'"></wt-input>
                    </div></td>
                    <td v-if="showStockQuantity"><div :class="$style['specifications-tr-input-div']">
                        <wt-input v-model="etem.stockQuantity" data-vv-as="规格库存" name="name" :class="$style['specifications-tr-input']"  v-validate="'required'"></wt-input>
                        </div>
                    </td>
                        <!-- <td v-if="isShowPromotionPrice">{{etem.promotionPrice}}</td>
                        <td>
                            <div  :class="$style['reward-money-just-salesman']">
                            <wt-input v-model="etem.inviterRewardMoney" @change="inviterRewardMoneyInput(etem)"></wt-input>
                            <el-checkbox v-model="etem.justSalesman" @change="justSalesmanChange(etem)">仅限业务员奖励</el-checkbox>
                            </div>
                        </td>
                        <td>
                            <wt-input v-model="etem.salerRewardMoney" @change="salerRewardMoneyInput(etem)"></wt-input>
                        </td> -->
                    <!-- <td></td> -->
                </tr>
            </table>
            </div>
        </pt-form-list-item>
    </table>
    <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog"  :class="$style['coupon-dialog']">
        <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit"  @close="closeDialog" :selected-coupon="coupon_list" :grantType="couponGrantType">
           <el-table-column label="已领取/剩余">
                  <template slot-scope="scope">
                      {{scope.row.getAmount+'/'+ (hasLimit(scope.row) ? scope.row.surplusAmount : '不限')}}
                  </template>
                </el-table-column>
        </coupon-list>
        <select-for-goods v-if="is_select_goods"  @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" :selected-goods="goods_list" :params="goodsParams"
         :disableArr="disableOfGoods" selectType="radio" isRadioSelectButton required></select-for-goods>
    </el-dialog>
</div>
</template>
<script>
import specificationTable from './specification-table'
import selectForGoods from 'cps/mall-manage/select-for-goods'
import couponList from 'cps/mall-manage/pt-promotion-coupon/coupon-list'
import formMixins from 'mixins/form'
import { isEmptyObject } from 'utils/formUtils'
import { couponTypeHasLimit } from 'json/mall-options'
export default {
  mixins: [formMixins],
  props: {
    widthMax: Number,
    goodsGroup: Array,
    value: Object,
    divideData: [Object, String],
    specification: Array,
    mallGoods: Object,
    isEdit: Boolean
  },
  components: {
    specificationTable,
    selectForGoods,
    couponList
  },
  data () {
    return {
      is_select_coupon: false,
      dialog_title: null,
      goodsData: JSON.parse(JSON.stringify(this.value)),
      privateResourcesUrl: this.$publicResourcesUrl,
      fileUploadUrlKey: this.$uploadApiKey,
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'goods',
        objectId: this.id || 0
      },
      picture_params_sim: {
        resourceName: 'goods',
        objectId: this.id || 0,
        key: 'file_path'
      },
      selectLabels: [],
      specifications: [],
      showStockQuantity: false,
      coupon_list: [],
      coupon_length: 0,
      is_select_goods: false,
      goods_list: {},
      goodsParams: {
        type: 'GENE'
      },
      disableOfGoods: [
        'type'
      ],
      focusIndex: null,
      first: false,
      divide_data: {},
      couponGrantType: 'BY_POINTS'
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (this.isEdit) this.goodsData = JSON.parse(JSON.stringify(val))
        this.coupon_list = (this.coupon_list && this.coupon_list.length) ? this.coupon_list : ((val && val.coupons && JSON.parse(JSON.stringify(val.coupons))) || [])
        this.coupon_length = this.coupon_list.length
      },
      deep: true
    },
    mallGoods: {
      handler: function (val) {
        this.goods_list = val
      }
    },
    goodsData: {
      handler: function (val) {
        this.$emit('change', val)
      },
      deep: true
    },
    divideData: {
      handler: function (val) {
        this.divide_data = typeof this.divideData === 'string' ? JSON.parse(this.divideData) : this.divideData

        this.goodsData = { ...this.goodsData, ...this.divide_data }
      }
    },
    'divide_data.type': {
      handler: function (val) {
        if (val !== 'GENE') {
          this.$delete(this.goodsData, 'mallGoodsId')
        }
        if (val !== 'COUPON') {
          this.$delete(this.goodsData, 'coupons')
        }
      }
    },
    specifications: {
      handler: function (val) {
        let data = {
          ...this.goodsData,
          specifications: val
        }
        this.$emit('change', data)
      },
      deep: true
    },
    specification: {
      handler: function (val) {
        this.specifications = val
      }
    }
  },
  computed: {
    // 是否显示商品列表（已选择商品）
    showGoodsTable () {
      return this.goods_list && !isEmptyObject(this.goods_list)
    },
    is_dialog: {
      get: function () {
        return this.is_select_coupon || this.is_select_goods
      },
      set: function (val) {
        this.is_select_coupon = val
        this.is_select_goods = val
      }
    },
    // 是否显示选择商品按钮
    isShowSelectGoods () {
      return this.divide_data.type === 'GENE'
    },
    // 是否显示选择优惠券按钮
    isShowSelectCoupon () {
      // return true
      return this.divide_data.type === 'COUPON'
    },
    // 是否显示优惠券列表
    showSelectCouponTable () {
      return this.coupon_list && this.coupon_list.length
    },
    // 是否允许添加规格
    allowAddSpecifications () {
      return this.divide_data.type !== 'COUPON' && this.specifications.length > 0
    }
  },
  methods: {
    hasLimit (row) {
      return couponTypeHasLimit(row)
    },
    getCouponsDetail (val) {
      this.$router.push('/promotion-coupon/coupon-detail/' + val.id)
    },
    showPriceFocus (index) {
      this.focusIndex = index
    },
    selectGoodsSubmit (val) {
      this.goods_list = val
      let goodsList = []
      goodsList.push(val)
      this.closeDialog()
      let goodsData = (val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData) || {}
      this.goodsData.mallGoodsId = goodsData.goodsId
    },
    selectGoods () {
      this.is_select_goods = true
      this.dialog_title = '选择基因商品'
    },
    showPriceInput (val) {
      // let items = this.specifications[0].items
      // this.specifications.forEach((item, index) => {
      //   if (index === this.focusIndex) {
      //     this.$set(item, 'show_price', val)
      //   }
      // })
      // if (val) {
      //   let price = minValueMethod(this.specifications, 'show_price') || (minValueMethod(this.specifications, 'show_price') === 0 ? 0 : null)
      //   this.$set(this.goodsData, 'final_price', price)
      // }
    },
    addSpecifications () {
      this.specifications = this.specifications || []
      this.specifications.push({
        // name: 'default',
        // items: [
        //   {
        name: '', // 明细项id
        stockQuantity: '',
        // show_price: '',
        price: '' // 影响的价格
        //   }
        // ]
      })
    },
    closeDialog () {
      this.is_dialog = false
    },
    changeCouponAmount (val, id) {
      this.coupon_list.forEach(item => {
        if (item.id === id) {
          item.couponAmount = val
        }
      })
      this.goodsData.coupons.forEach(item => {
        item.couponAmount = typeof val === 'number' ? val : parseInt(val)
      })
    },
    selectCouponSubmit (val) {
      this.coupon_list = val
      this.goodsData.coupons = []
      val.forEach(item => {
        this.coupon_length = this.coupon_length + 1
        this.goodsData.coupons.push({
          id: item.id,
          couponAmount: item.couponAmount
        })
      })
      this.closeDialog()
    },
    setGroup () {
      this.$router.push('/integral-goods-group')
    },
    selectCoupon () {
      this.is_select_coupon = true
      this.dialog_title = '选择优惠劵'
    },
    widthItem (val) {
      this.$emit('widthItem', val)
    },
    addDefaultSpecifications () {
      this.specifications = []
      this.specifications.push({
        // name: 'default',
        // items: [
        //   {
        name: '默认规格', // 明细项id
        stockQuantity: '',
        // show_price: '',
        price: '' // 影响的价格
        //   }
        // ]
      })
    }
  },
  created () {
    this.showStockQuantity = this.$store.getters.showStockQuantity
    this.addDefaultSpecifications()
  }
}
</script>
<style module lang="less">
.coupon-dialog{
    :global
    .el-dialog{
        width: 70%;
        max-width: 900px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
.goods-name{
    max-width: 350px;
}
.specification-table-div{
     padding: 10px 20px 30px;
     max-width: 500px;
}
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.goods-table{
     display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.table-of-button{
  margin-bottom: 10px;
}
.message-table{
  :global{
    textarea{
      max-width: 350px;
    }
  }
}
</style>
<style lang="less">

.goods-pictrue-upload{
    .el-upload--picture-card{
        width: 212px;
        height: 150px;
        display:inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
}
.main-pictrue-upload{
    .el-upload--picture-card{
        width: 150px;
        height: 150px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
}
.goods-banner-pictrue-upload{
 .el-upload--picture-card{
        width: 347px;
        height: 128px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
         box-sizing:inherit
    }
}
</style>
